











































import { Component, Vue } from 'vue-property-decorator';
import play from '@/resources/directives/play';
import CameraPageHeader from '@/components/CameraPageHeader.vue';
import GuideGpdocIntroduction from '@/components/GuideGpdocIntroduction.vue';
import FooterButton from '@/components/FooterButton.vue';

@Component({
  components: {
    CameraPageHeader,
    GuideGpdocIntroduction,
    FooterButton
  },
  directives: {
    play
  }
})
export default class Page extends Vue {
  private scrollerHeight: number = 0;

  private get isScroll(): boolean {
    return this.scrollerHeight > this.$store.state.camera.displayHeight;
  }

  public mounted(): void {
    this.calcDynamicAreaHeight();
  }

  public updated(): void {
    this.calcDynamicAreaHeight();
  }

  private calcDynamicAreaHeight(): void {
    if (!this.$el) return;
    const scroller: HTMLDivElement = this.$el.getElementsByClassName('page-scroller').item(0) as HTMLDivElement;
    const scrollerRect: DOMRect = scroller.getBoundingClientRect() as DOMRect;
    this.scrollerHeight = scrollerRect.height;
  }
}
